"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MemberStatus = void 0;
/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
var MemberStatus;
(function (MemberStatus) {
    MemberStatus["ACTIVE"] = "ACTIVE";
    MemberStatus["INACTIVE"] = "INACTIVE";
    MemberStatus["PENDING_REMOVE"] = "PENDING_REMOVE";
    MemberStatus["Active"] = "ACTIVE";
    MemberStatus["Inactive"] = "INACTIVE";
    MemberStatus["PendingRemove"] = "PENDING_REMOVE";
})(MemberStatus || (exports.MemberStatus = MemberStatus = {}));
